var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home",class:_vm.platform},[_c('Header',{attrs:{"platform":_vm.platform}}),_c('MainContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }